<template>
    <div :class="['hlDrillProc',getPlatformClass]">

        <div :class="['techDrillScroller']">
          <div :class="['drillProcCont2', isDrillFadeout === true ? 'drillFadeout' : '']">          
              <img class="itemImg" :src="infoImg" />            
              <div class="itemTitle">
                <div>
                  <b>{{selectedItemData.title}}</b>
                  <br/>
                  <br/>
                  {{selectedItemData.description}}
                </div>
              </div>
          </div>
        </div>

        <div :class="['drillplatformBarContainer',plaformIndex>-1 ? 'mounted':'']">
          <platformbar 
            skinMode = "light"
            v-bind:affectOtherSections = "false"
            v-bind:sectionIndex = "4"
            @platform-change="onPlatformChange">
          </platformbar>
        </div>
        

    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import platformbar from "@/views/com/platformbar.vue";
import splitter from "@/views/com/splitter.vue";

export default {
    components:{platformbar,splitter},
    props: {  
        sectionType:String,
        sectionIndex:Number,
    },
    data()
    {
        return {            
            infoImg:'',
            plaformIndex:-1,
            isDrillFadeout:true
        }
    },
    mounted()
    {
      //this.componentData = this.getSiteTechTabData();
      var vm=this;
      setTimeout(() => {
        vm.$forceUpdate();  
      }, 1000);
      
    },
    methods:
    {
      getSiteTechTabData()
      {
          var pageSections = this.pageLayoutData.children[0].children;        
          var techTabsSection = pageSections.filter(x => x.type == "propage-technical");
          var targetNodes = techTabsSection[0].children[0].children;
          var targetNode = targetNodes[this.sectionIndex];//.filter(x => x.template == this.sectionType)[0];
          return targetNode;
      },
      getImgByIndex(plaformIndex)
      {
          return "https://mis-implants.com/upload"+this.componentData.files[plaformIndex].file_url;//file_url
      },
      onPlatformChange(plaformIndex)
      {
        var vm = this;        
        vm.isDrillFadeout = true;        
        setTimeout(() => {
          vm.plaformIndex = plaformIndex;
          vm.infoImg = this.getImgByIndex(plaformIndex);// vm.sectionData.platforms[plaformIndex].img;  
        }, 500);
        setTimeout(() => {
          vm.isDrillFadeout = false;
        }, 1100);        
      },
      getStyleIndex(index){
        return "--index:"+index;
      }
    },
    computed:{
        ...mapState(["pageLayoutData","xSelectedPlatform","minisite_data","siteDataReady"]),
        componentData()
        {
            return this.getSiteTechTabData();
        },
        selectedItemData()
        {
            if(this.plaformIndex<0){
              return '';
            }
            return this.componentData!=null ? this.componentData.files[this.plaformIndex] : '';
        },
        getItemsData()
        {
            return this.componentData.files;//file_url
        },
        getPlatformClass()
        {
          //We can finally animate CSS gradient:
          //https://dev.to/afif/we-can-finally-animate-css-gradient-kdk
          return this.plaformIndex>-1 ? "platform_"+this.plaformIndex: '';
        },
        sectionData(){
            return this.minisite_data.SECTIONS[this.sectionDataIndex];
        }

    }
};
</script>

<style>
    .hlDrillProc
    {      
        background: transparent;
        position:relative;
        width: 100%;
        height: 100%;        
        z-index: 100;
        /* display: grid; */
        /* align-items: center; */
    }
    .hlDrillProc .container
    {
      width: 100%;
    }
    .hlDrillProc .title
    {
        font-size: 18px !important;
        font-weight: 100 !important;
        font-weight: 400 !important;        
        letter-spacing: -0.5px;
        color: var(--text-blue);
        text-align:left;        
        position:absolute;
        top:0px;left: 0px;
        padding-left: max(180px, 10vw);
        top:100px;
        
    }
    .hlDrillProc .lowerText
    {
        position: absolute;
        bottom: 50px;
        left: 12vw;
        width: 76vw;
        font-size: 16px;
        opacity: 0;
    }
    .hlDrillProc .lowerText.mounted
    {
      opacity: 1;
    }

    .hlDrillProc .techDrillScroller
    {
      padding-top: 20px;
    }

    .hlDrillProc .drillplatformBarContainer
    {
      position: absolute;
      transition: all 1s cubic-bezier(0.645, 0.045, 0.355, 1.000);
      /* position: absolute;bottom: 30px; */
      width: 100%;
    }
    .hlDrillProc .drillplatformBarContainer.mounted
    {
      /*top:calc(100vh - 150px);*/
      bottom: 10px;
    }      
    .drillProcCont2
    {
      /* position: absolute;top:47%;transform: translateY(-50%); */
      width: 100%;text-align: center;
      color:#fff;
      pointer-events: none;
      opacity: 1;
      transition: all ease 0.5s;
      background: transparent;
      /* border: solid 2px red; */
      position: relative;
    }
    .drillProcCont2.drillFadeout
    {
      opacity: 0;
    }

    .drillProcCont2 .itemImg
    {
      width: 45vw;height:auto;
    }
    .drillProcCont2 .itemTitle
    {
      position: absolute;
      left: 5vw;
      top: 0px;
      display: flex;
      align-items: center;
      height: 100%;
    }
    .drillProcCont2 .itemTitle> div
    {
      font-size: 14px;font-weight: 300;
      color: #202020;
      width: 20vw;
      text-align: left;
    }

  @media (hover: hover) {
  }

  @media (max-width: 850px) { 
    .hlDrillProc
    {
        min-height: auto;
        width: 100%;
        overflow: hidden;
    }
    .hlDrillProc .techDrillScroller
    {
      display: block;
      max-width: 100%;
      height: auto;
      overflow-x: auto;
      overflow-y: hidden;
      padding: 0px 20px 20px 20px;
    }    
    .drillScroller::-webkit-scrollbar {
        display: none;
    }
    .drillScroller.scrollerFadeout
    {
      opacity: 0 !important;
    }
    .hlDrillProc .drillplatformBarContainer
    {
      position:static;
      transform: none;
      width: 100%;
      padding-top: 0px;
      border-radius: 0px 0px 20px 20px;
      overflow: hidden;
    }    

    .drillProcCont2
    {
      width: 100%;
      padding-left: 0px;
      height: auto;
      padding-bottom: 50px;
    }    
    .drillProcCont2 .itemImg
    {      
      width: 100% !important;
      height: auto;
    }
    .hlDrillProc .lowerText
    {
        clear: both;
        font-size: 15px;
        margin: auto;        
        position: static;
        padding: 30px 0px 0px 0px;        
    }    
    .drillProcCont2 .itemTitle {
        position: initial;
        display: flex;
        height: auto;
        width: 100%;
        padding-top: 30px;
    }
    .drillProcCont2 .itemTitle> div {
        width: 100%;
        text-align: left;
    }

  }  
</style>